import $ from 'jquery';
import showOnScroll from '@zerofool/show-on-scroll';

$(() => {
	showOnScroll('.case-studies .case-study-card');

	if (window.innerWidth >= 768) {
		showOnScroll('.show-case-studies .case-study-card');
	} else {
		showOnScroll('.show-case-studies .show-case-studies__inner');
	}
});